export default {
    computed: {
        isUserPage() {
            return this.$route.name == "user-management";
        },
        isTranstanPage() {
            return this.$route.name == "transtan-management" || this.$route.name == "sotto-management";
        }
    }
}